// extracted by mini-css-extract-plugin
export default {"container":"zl","overlay":"Al","videoOverlay":"Bl","withHeader":"Cl","header":"Dl","close":"El","content":"Fl"};